export default __webpack_public_path__ + "static/media/Head_6_Ear_3_C3.88fdf523.svg";